import { Button } from '@/components/button/Button'
import { Modal, ModalClose, ModalContent, ModalTitle } from '@/components/modal/Modal'
import { type ExternalStorageProvider } from '@/constants/constants-external-storage'
import AppIcon from '@/settings/components/AppIcon'
import { PROVIDER_META } from '@/user_files/external-storage/ProviderMeta'
import { brandedAIFriendlyName } from '@/util/enterprise'

export default function ConnectRedirectDialog({
  provider,
  open,
  loading,
  onOpenChange,
  onContinue,
}: {
  provider: ExternalStorageProvider | null
  open: boolean
  loading: boolean
  onOpenChange: (open: boolean) => void
  onContinue: () => void
}) {
  if (!provider) return null

  const meta = PROVIDER_META[provider]
  const descriptionId = `connect-${provider}-description`

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent width="lg" height="max-sm" aria-describedby={descriptionId}>
        <div className="flex flex-col items-center">
          <div className="mb-6 flex items-center gap-2">
            <AppIcon />
            <div className="flex items-center gap-1.5" aria-hidden="true">
              <span className="h-[5px] w-[5px] rounded-full bg-brand-neutral-300" />
              <span className="h-[5px] w-[5px] rounded-full bg-brand-neutral-300" />
              <span className="h-[5px] w-[5px] rounded-full bg-brand-neutral-300" />
            </div>
            <div className="flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-md border border-brand-neutral-200 bg-white">
              {meta.modalIcon}
            </div>
          </div>

          <ModalTitle className="text-center text-xl font-semibold leading-7 text-brand-neutral-950">Connect {meta.label}</ModalTitle>
          <p id={descriptionId} className="mt-1.5 max-w-[520px] text-center text-base leading-6 tracking-[-0.32px] text-brand-neutral-950">
            You'll be redirected to {meta.label} to authorize the connection. This gives {brandedAIFriendlyName} access to your {meta.label}. No files are
            synced until you map folders to matters.
          </p>

          <div className="mt-6 flex w-full justify-end gap-3">
            <ModalClose asChild>
              <Button type="button" disabled={loading} variant="outlined" color="primary" size="md">
                Cancel
              </Button>
            </ModalClose>
            <Button type="button" onClick={onContinue} disabled={loading} loading={loading} className="min-w-[140px]">
              Continue to {meta.label}
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  )
}
